import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { SHIPPING_CONDITION_CODE } from '../../../../../../shared/constants/shipping-conditions-codes';
import { simmaUL } from './delivery/simma-ul.config';

export const readymix = {
  [SHIPPING_CONDITION_CODE.DELIVERY]: {
    [ORDER_EXPERIENCES.SIMMA_UNIVERSAL_LINK]: simmaUL,
  },
};
